module.exports = __webpack_public_path__ + "static/media/logo-cooperativa.e77478f8.svg";